var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
import React from 'react';
import { ASC, COLUMN, DATAGRID, DESC, SELECT } from '../../constants';
import classes from '../../utils/classes';
import cssPrefix from '../../utils/cssPrefix';
import withMemoRef from '../../utils/withMemoRef';
/**
 * DataGrid prefix.
 */
const dataGridPrefix = cssPrefix(DATAGRID);
/**
 * DIRT: Column minimal width.
 */
const COLUMN_MIN_WIDTH = 38;
/**
 * DataGridColumn component.
 *
 * @param props DataGridColumn properties.
 */
export const DataGridColumn = withMemoRef('DataGridColumn', (_a, ref) => {
  var {
      className,
      fixed = false,
      selected = false,
      sort = '',
      style = {},
      width
    } = _a,
    props = __rest(_a, [
      'className',
      'fixed',
      'selected',
      'sort',
      'style',
      'width'
    ]);
  return React.createElement(
    'th',
    Object.assign(
      {
        className: classes(
          dataGridPrefix(COLUMN),
          {
            [dataGridPrefix(SELECT)]: selected,
            [sort]: sort === ASC || sort === DESC
          },
          className
        ),
        style: Object.assign(
          Object.assign(
            {},
            width || fixed
              ? { '--datagrid-column-width': `${width || COLUMN_MIN_WIDTH}px` }
              : {}
          ),
          style
        )
      },
      Object.assign(Object.assign({}, props), { ref })
    )
  );
});
export default DataGridColumn;
